import FormControlLabel from '@mui/material/FormControlLabel';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import IOSSwitch from '../IOSSwitch/IOSSwitch';
import { RoundedSkeleton } from './LoadingSkeleton';
import {
  ClientStatus,
  changeClientStatus,
  IChangeClientStatusPayload,
} from '../../redux/client/clientSlice';
import createPermissionCheckers from '../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../types/commonTypes';
import { ClientLimitStatus } from '../../redux/coach/coachSlice';

interface IStatusSwitchProps {
  isActive: boolean;
  rowId: string;
}

const StatusSwitch = ({ isActive, rowId }: IStatusSwitchProps) => {
  const dispatch = useAppDispatch();
  const [value, setValue] = useState(isActive);
  const { changeClientStatusLoading, statusChangedClientId } = useAppSelector(
    (state) => state.client
  );
  const clientLimitStatus = useAppSelector((state) => state.coach.coach.clientCountStatus);
  const coachId = useAppSelector((state) => state.coach.coach?.id);
  const { t } = useTranslation();
  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;
  const { id } = useParams();
  const handleToggle = () => {
    const data: IChangeClientStatusPayload = {
      clientId: rowId,
      status: !value ? ClientStatus.ENABLE : ClientStatus.DISABLE,
      coachId,
      clientGroupId: id,
    };
    setValue(!value);
    dispatch(changeClientStatus(data));
  };

  if (!rowId) return null;

  return changeClientStatusLoading && statusChangedClientId === rowId ? (
    <Grid gap={1} display="flex" flexDirection="row" alignItems="center">
      <RoundedSkeleton variant="rounded" width={30} height={24} />
      <RoundedSkeleton variant="rounded" width={70} height={14.875} />
    </Grid>
  ) : (
    <FormControlLabel
      key={rowId}
      control={<IOSSwitch isActive={value} toggleButton={handleToggle} rowId={rowId} />}
      label={value ? t('common.active') : t('common.inactive')}
      sx={{
        gap: '10px',
        '&.Mui-disabled .MuiTypography-root': {
          color: 'inherit',
        },
      }}
      disabled={
        !checkPermissions(UserPermissionType.CORE_MODULE_CHANGE_CLIENT_STATUS) ||
        (!value && clientLimitStatus === ClientLimitStatus.LIMIT_REACHED)
      }
    />
  );
};

export default StatusSwitch;
